import { editorBlockContentFragment } from '@getaccept/editor-lib';
import gql from 'graphql-tag';

export const createRowMutation = gql`
  mutation createRow(
    $documentId: String
    $dealroomId: String
    $resourceId: String
    $dsrTemplateId: String
    $dsrResourceId: String
    $contentId: String!
    $targetSectionId: String!
    $targetRowId: String
    $append: Boolean
    $payload: CreateRowInput!
    $hidden: Boolean
  ) {
    createRow(
      documentId: $documentId
      dealroomId: $dealroomId
      resourceId: $resourceId
      dsrTemplateId: $dsrTemplateId
      dsrResourceId: $dsrResourceId
      contentId: $contentId
      targetSectionId: $targetSectionId
      targetRowId: $targetRowId
      append: $append
      payload: $payload
      hidden: $hidden
    ) {
      id
    }
  }
`;

export const createSectionMutation = gql`
  mutation createSection(
    $documentId: String
    $dealroomId: String
    $resourceId: String
    $dsrTemplateId: String
    $dsrResourceId: String
    $contentId: String!
    $targetSectionId: String
    $append: Boolean
    $payload: CreateSectionInput!
  ) {
    createSection(
      documentId: $documentId
      dealroomId: $dealroomId
      resourceId: $resourceId
      dsrTemplateId: $dsrTemplateId
      dsrResourceId: $dsrResourceId
      contentId: $contentId
      targetSectionId: $targetSectionId
      append: $append
      payload: $payload
    ) {
      id
    }
  }
`;

export const moveCellMutation = gql`
  mutation moveCell(
    $documentId: String
    $dealroomId: String
    $resourceId: String
    $dsrTemplateId: String
    $dsrResourceId: String
    $contentId: String!
    $sourceSectionId: String!
    $sourceRowId: String!
    $sourceCellId: String!
    $targetSectionId: String!
    $targetRowId: String!
    $targetCellId: String
    $append: Boolean
  ) {
    moveCell(
      documentId: $documentId
      dealroomId: $dealroomId
      resourceId: $resourceId
      dsrTemplateId: $dsrTemplateId
      dsrResourceId: $dsrResourceId
      contentId: $contentId
      sourceSectionId: $sourceSectionId
      sourceRowId: $sourceRowId
      sourceCellId: $sourceCellId
      targetSectionId: $targetSectionId
      targetRowId: $targetRowId
      targetCellId: $targetCellId
      append: $append
    )
  }
`;

export const moveSectionMutation = gql`
  mutation moveSection(
    $documentId: String
    $dealroomId: String
    $resourceId: String
    $dsrTemplateId: String
    $dsrResourceId: String
    $contentId: String!
    $sourceSectionId: String!
    $targetSectionId: String!
    $append: Boolean
    $targetContentId: String
  ) {
    moveSection(
      documentId: $documentId
      dealroomId: $dealroomId
      resourceId: $resourceId
      dsrTemplateId: $dsrTemplateId
      dsrResourceId: $dsrResourceId
      contentId: $contentId
      sourceSectionId: $sourceSectionId
      targetSectionId: $targetSectionId
      append: $append
      targetContentId: $targetContentId
    )
  }
`;

export const moveRowMutation = gql`
  mutation moveRow(
    $documentId: String
    $dealroomId: String
    $resourceId: String
    $dsrTemplateId: String
    $dsrResourceId: String
    $contentId: String!
    $sourceSectionId: String!
    $sourceRowId: String!
    $targetContentId: String
    $targetSectionId: String!
    $targetRowId: String
    $append: Boolean
  ) {
    moveRow(
      documentId: $documentId
      dealroomId: $dealroomId
      resourceId: $resourceId
      dsrTemplateId: $dsrTemplateId
      dsrResourceId: $dsrResourceId
      contentId: $contentId
      sourceSectionId: $sourceSectionId
      sourceRowId: $sourceRowId
      targetContentId: $targetContentId
      targetSectionId: $targetSectionId
      targetRowId: $targetRowId
      append: $append
    )
  }
`;

export const updateRowMutation = gql`
  mutation updateRow(
    $documentId: String
    $dealroomId: String
    $resourceId: String
    $dsrTemplateId: String
    $dsrResourceId: String
    $contentId: String!
    $targetSectionId: String!
    $targetRowId: String!
    $payload: UpdateRowInput!
  ) {
    updateRow(
      documentId: $documentId
      dealroomId: $dealroomId
      resourceId: $resourceId
      dsrTemplateId: $dsrTemplateId
      dsrResourceId: $dsrResourceId
      contentId: $contentId
      targetSectionId: $targetSectionId
      targetRowId: $targetRowId
      payload: $payload
    )
  }
`;

export const updateSectionMutation = gql`
  mutation updateSection(
    $documentId: String
    $dealroomId: String
    $resourceId: String
    $dsrTemplateId: String
    $dsrResourceId: String
    $contentId: String!
    $targetSectionId: String!
    $payload: UpdateSectionInput!
  ) {
    updateSection(
      documentId: $documentId
      dealroomId: $dealroomId
      resourceId: $resourceId
      dsrTemplateId: $dsrTemplateId
      dsrResourceId: $dsrResourceId
      contentId: $contentId
      targetSectionId: $targetSectionId
      payload: $payload
    )
  }
`;

export const updateNodeMutation = gql`
  mutation updateNode(
    $documentId: String
    $dealroomId: String
    $resourceId: String
    $dsrTemplateId: String
    $dsrResourceId: String
    $contentId: String!
    $targetSectionId: String!
    $targetRowId: String!
    $targetCellId: String!
    $targetNodeId: String!
    $payload: NodeInput!
  ) {
    updateNode(
      documentId: $documentId
      dealroomId: $dealroomId
      resourceId: $resourceId
      dsrTemplateId: $dsrTemplateId
      dsrResourceId: $dsrResourceId
      contentId: $contentId
      targetSectionId: $targetSectionId
      targetRowId: $targetRowId
      targetCellId: $targetCellId
      targetNodeId: $targetNodeId
      payload: $payload
    ) {
      id
    }
  }
`;

export const updateCellsMutation = gql`
  mutation updateCells(
    $documentId: String
    $dealroomId: String
    $resourceId: String
    $dsrTemplateId: String
    $dsrResourceId: String
    $contentId: String!
    $targetSectionId: String!
    $targetRowId: String!
    $payload: [UpdateCellInput!]!
  ) {
    updateCells(
      documentId: $documentId
      dealroomId: $dealroomId
      resourceId: $resourceId
      dsrTemplateId: $dsrTemplateId
      dsrResourceId: $dsrResourceId
      contentId: $contentId
      targetSectionId: $targetSectionId
      targetRowId: $targetRowId
      payload: $payload
    )
  }
`;

export const splitRowMutation = gql`
  mutation splitRow(
    $documentId: String
    $dealroomId: String
    $resourceId: String
    $dsrTemplateId: String
    $dsrResourceId: String
    $contentId: String!
    $targetSectionId: String!
    $targetRowId: String!
    $targetCellId: String!
    $targetNodeId: String!
    $splitInput: SplitNodeInput!
    $createInput: [SplitRowCreateInput!]!
    $hidden: Boolean
  ) {
    splitRow(
      documentId: $documentId
      dealroomId: $dealroomId
      resourceId: $resourceId
      dsrTemplateId: $dsrTemplateId
      dsrResourceId: $dsrResourceId
      contentId: $contentId
      targetSectionId: $targetSectionId
      targetRowId: $targetRowId
      targetCellId: $targetCellId
      targetNodeId: $targetNodeId
      splitInput: $splitInput
      createInput: $createInput
      hidden: $hidden
    )
  }
`;

export const deleteRowMutation = gql`
  mutation deleteRow(
    $documentId: String
    $dealroomId: String
    $resourceId: String
    $dsrTemplateId: String
    $dsrResourceId: String
    $contentId: String!
    $targetSectionId: String!
    $targetRowId: String!
  ) {
    deleteRow(
      documentId: $documentId
      dealroomId: $dealroomId
      resourceId: $resourceId
      dsrTemplateId: $dsrTemplateId
      dsrResourceId: $dsrResourceId
      contentId: $contentId
      targetSectionId: $targetSectionId
      targetRowId: $targetRowId
    )
  }
`;

export const deleteSectionMutation = gql`
  mutation deleteSection(
    $documentId: String
    $dealroomId: String
    $resourceId: String
    $dsrTemplateId: String
    $dsrResourceId: String
    $contentId: String!
    $targetSectionId: String!
    $deletedPricingTableIds: [String!]
  ) {
    deleteSection(
      documentId: $documentId
      dealroomId: $dealroomId
      resourceId: $resourceId
      dsrTemplateId: $dsrTemplateId
      dsrResourceId: $dsrResourceId
      contentId: $contentId
      targetSectionId: $targetSectionId
      deletedPricingTableIds: $deletedPricingTableIds
    )
  }
`;

export const createImageV2Mutation = gql`
  mutation CreateImageV2(
    $type: ImageType!
    $fileInfo: FileInfo
    $url: String
    $name: String
    $externalId: String
  ) {
    createImageV2(
      type: $type
      fileInfo: $fileInfo
      url: $url
      name: $name
      externalId: $externalId
    ) {
      image {
        id
        url
        imageUrl
        externalId
        height
        width
      }
      uploadLink {
        url
        headers
      }
    }
  }
`;

export const updateContentMutation = gql`
  mutation updateEditorContent($targetContentIds: [String!]!, $payload: UpdateEditorContentInput!) {
    updateEditorContent(targetContentIds: $targetContentIds, payload: $payload)
  }
`;

export const copyEditorContentMutation = gql`
  mutation copyEditorContent($id: String!) {
    copyEditorBlock(id: $id) {
      content {
        ...editorBlockContentFragment
      }
    }
  }
  ${editorBlockContentFragment}
`;

export const useDsrEditorResource = gql`
  mutation useDsrEditorResource($payload: UseDsrEditorResourceInput!) {
    useDsrEditorResource(payload: $payload)
  }
`;

export const createDrResourceFromContent = gql`
  mutation createDrResourceFromContent($payload: CreateDealroomEditorResourceFromContentInput!) {
    createDealroomEditorResourceFromContent(payload: $payload) {
      id
    }
  }
`;
